module.exports = __webpack_public_path__ + "static/img/banners1.fa85193.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners1.jpg
// module id = SLEA
// module chunks = 4